import { Injectable, signal } from '@angular/core';

export type ToastLevel = 'info' | 'warning' | 'success' | 'error';

export interface Toast {
  message: string;
  level:   ToastLevel;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toast = signal<Toast | null>(null);
  readonly toast = this._toast.asReadonly();

  private timer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, level: ToastLevel, duration = 4000): void {
    if (this.timer !== null) clearTimeout(this.timer);
    this._toast.set({ message, level });
    this.timer = setTimeout(() => this._toast.set(null), duration);
  }

  dismiss(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this._toast.set(null);
  }
}
